import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation deleteOfferMutation($input: DeleteOfferInput!) {
    deleteOffer(input: $input) {
      destroyedOfferId
      lists {
        ...OffersContainer_lists
      }
    }
  }
`;

const deleteOffer = (environment, offerId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: offerId,
      },
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'Offers_offers' }],
        pathToConnection: ['lists', 'offers'],
        deletedIDFieldName: 'destroyedOfferId',
      },
    ],
    ...args,
  });
};

export default deleteOffer;
